import { NavLink, useLocation } from 'react-router';

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { orgPath, stripOrgPrefix } from '@/utils/org-path';
import {
  resolveActiveSection,
  useNavSections,
  type NavSection,
} from '@/components/navigation/use-nav-sections';

/** Taskbar icon for a grouped destination; opens the section's panel. */
export function NavSectionRailButton({ section }: { section: NavSection }) {
  const pathname = stripOrgPrefix(useLocation().pathname);
  const sections = useNavSections();
  const Icon = section.icon;
  // Exactly one icon lights up, even where sections share a route prefix.
  const isActive = resolveActiveSection(sections, pathname)?.id === section.id;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton tooltip={section.title} asChild isActive={isActive}>
        <NavLink to={orgPath(section.landing)}>
          <Icon />
          <span>{section.shortTitle ?? section.title}</span>
        </NavLink>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
